import React from 'react';
import { Clock, Users, Award } from 'lucide-react';
import { Reveal } from './Reveal';

const points = [
  {
    icon: Clock,
    title: 'On-Time Delivery',
    description: 'Every project ships on schedule, so your launch never waits on your media.'
  },
  {
    icon: Users,
    title: 'One Unified Team',
    description: 'From raw footage to final cut and marketing guidance — handled by a single team.'
  },
  {
    icon: Award,
    title: 'Consistent Quality',
    description: 'High-end, on-brand production across every video, every single time.'
  }
];

const Problem = () => {
  return (
    <section id="problem" className="section-padding bg-[#050505] border-t border-white/5" data-testid="problem-section">
      <div className="max-w-7xl mx-auto">
        <Reveal className="max-w-3xl mb-16">
          <p className="overline mb-5">The Problem</p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05] text-white mb-6">
            Generic media <span className="gold-gradient">kills momentum.</span>
          </h2>
          <p className="text-lg md:text-xl text-[#a0a0a0] leading-relaxed">
            Forgettable videos get scrolled past. Missed deadlines stall your launches. You deserve a
            media partner that moves as fast as you do — and makes you unforgettable.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {points.map((point, index) => {
            const Icon = point.icon;
            return (
              <Reveal key={index} delay={index * 0.1}>
                <div
                  className="h-full bg-[#0f0f0f] border border-white/5 rounded-2xl p-8 md:p-10 hover:border-[#d4af37]/40 transition-colors duration-500"
                  data-testid={`problem-card-${index}`}
                >
                  <Icon size={40} className="text-[#d4af37] mb-6" strokeWidth={1.25} />
                  <h3 className="text-2xl font-semibold text-white mb-3">{point.title}</h3>
                  <p className="text-[#a0a0a0] leading-relaxed">{point.description}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Problem;
